// export const DYNAMIC = 'DYNAMIC';
export const JUDETE = 'JUDETE';
export const EMPLOYER_TYPE = 'EMPLOYER_TYPE';
export const FORMA_JURIDICA = 'FORMA_JURIDICA';
export const PROPERTY_TYPE = 'PROPERTY_TYPE';
export const EMPLOYER_SIZE = 'EMPLOYER_SIZE';
export const EMPLOYEE_CONTRACT_STATUS = 'EMPLOYEE_CONTRACT_STATUS';
export const SEX_TYPE = 'SEX_TYPE';
export const STARE_CIVILA = 'STARE_CIVILA';
export const PERSOANE_INTRETINERE = 'PERSOANE_INTRETINERE';
export const CETATENIE = 'CETATENIE';
export const STATUT_PROFESIONAL = 'STATUT_PROFESIONAL';
export const DURATA_MUNCII = 'DURATA_MUNCII';
export const ANGAJAT_AUTORIZAT_ISCIR = 'ANGAJAT_AUTORIZAT_ISCIR';
export const ANGAJAT_AUTORIZAT_INTERN = 'ANGAJAT_AUTORIZAT_INTERN';
export const ANGAJAT_AUTORIZAT_TYPES = 'ANGAJAT_AUTORIZAT_TYPES';
export const CLIENT_TYPE = 'CLIENT_TYPE';
export const CLIENT_SERVICE_TYPE = 'CLIENT_SERVICE_TYPE';
export const SYSTEM_USER_ROLES = 'SYSTEM_USER_ROLES';
export const CLIENT_USER_ROLES = 'CLIENT_USER_ROLES';
export const TASK_STATUS = 'TASK_STATUS';
export const AUTHORIZATION_STATUS = 'AUTHORIZATION_STATUS';
export const COURSE_REGISTRATION_STATUS = 'COURSE_REGISTRATION_STATUS';
export const INSTALATII_PERSONAL_AUXILIAR = 'INSTALATII_PERSONAL_AUXILIAR';
